import React, { useState, useEffect } from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Skeleton from '@material-ui/lab/Skeleton';
import Slide from '@material-ui/core/Slide';
import { toast } from 'react-toastify';

import ConfirmCheckoutDialog from './DialogConfirmCheckout';
import moment from 'moment';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { collection, query, where, getDocs } from 'firebase/firestore/lite';
import { firebaseFireStore } from '../../config/firebaseFirestore';
import { httpsCallable } from 'firebase/functions';
import { firebaseFunctions } from '../../config/firebaseFunctions';
import Head from 'next/head';
import { Radio } from 'antd';
import { walletID } from '../../config/fire-conf';
import { useDispatch, useSelector } from 'react-redux';
import { getwalletBal } from '../../services/common-query';
import { formatUSDBalance } from '@/services/formatBalance';
import {
  musicartWallet,
  handCashBSVWallet,
  handCashUSDCWallet,
} from '../../config/wallets';
import { verifyUserHandcashHandle } from '@/services/common-query';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CheckoutDialog(props) {
  const bsvRate = useSelector((state) => state.bsvRateReducer.bsvRate);
  const userAuthToken = useSelector((state) => state.authReducer.userauthtoken);
  const userDataRedux = useSelector((state) => state.authReducer.userData);
  const handCashWalletRedux = useSelector((state) => state.handCashReducer);

  const [loading, setloading] = useState(false);
  const userWalletRedux = useSelector((state) => state.walletReducer);
  const [
    confirmationConfirmCheckoutDialogState,
    setconfirmationConfirmCheckoutDialogState,
  ] = useState(false);
  const [promoCodeField, setpromoCodeField] = useState('');
  const [promoCodeObj, setpromoCodeObj] = useState(null);
  const [promocodeLoading, setpromocodeLoading] = useState(false);
  const [transactionTxid, settransactionTxid] = useState('-');
  const [isAgreedPolicy, setIsAgreedPolicy] = useState(false);
  const [isAgreedTerms, setIsAgreedTerms] = useState(false);
  const [render, setRender] = useState(false);
  const [selectedWallet, setselectedWallet] = useState(musicartWallet);
  const [showBuyingOpt, setshowBuyingOpt] = useState('loading');
  const [showUsdcOpt, setshowUsdcOpt] = useState(false);

  const dispatch = useDispatch();

  const handleClose = () => {
    props.setdialogState(false);
    setpromoCodeField('');
    setpromoCodeObj(null);
  };

  const onPolicy = (event) => {
    setIsAgreedPolicy(event.target.checked);
  };

  const onTerms = (event) => {
    setIsAgreedTerms(event.target.checked);
  };

  const confirmPurchase = async (e) => {
    setloading(true);
    try {
      if (!isAgreedPolicy) {
        toast.error('Please agree to the Privacy Policy.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }
      if (!isAgreedTerms) {
        toast.error('Please agree to the Terms and Conditions.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setloading(false);
        return;
      }

      if (props?.nftData?.buyWithCouponOnly) {
        if (!promoCodeObj) {
          toast.error(
            'Please provide the coupon, this NFT can only be purchased with coupon',
            {
              position: 'bottom-left',
              autoClose: 10000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
            },
          );
          setloading(false);

          return;
        }
      } else {
        let cPrice =
          promoCodeObj &&
          (promoCodeObj.discountedPrice || promoCodeObj.discountedPrice === 0)
            ? Number(promoCodeObj.discountedPrice)
            : props.nftData.price;

        let walletBalance = Number(userWalletRedux.balance * bsvRate); //$

        if (selectedWallet === handCashBSVWallet) {
          walletBalance =
            handCashWalletRedux?.balance[1]?.spendableBalance * bsvRate;
        }
        // else if (selectedWallet === handCashUSDCWallet) {
        //   walletBalance = handCashWalletRedux?.balance[0]?.spendableBalance;
        // }

        if (walletBalance < Number(cPrice)) {
          console.log('error local');

          toast.error('Insufficient balance in wallet', {
            position: 'bottom-left',
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setloading(false);
          return;
        }
      }

      let musicartNftPurchaseAPI = httpsCallable(
        firebaseFunctions,
        'musicartNftPurchase',
        {
          timeout: 300000,
        },
      );
      let musicartNftPurchaseRes = await musicartNftPurchaseAPI({
        tokenId: props.nftData.tokenId,
        recipientAddress: userWalletRedux.paymail,
        isMultiple: props.nftData.isMultiple,
        nftId: props.nftData.nftId ? props.nftData.nftId : null,
        userAuthToken: userAuthToken,
        sn: props.nftData.index ? Number(props.nftData.index) : 1,
        promoCodeObj: promoCodeObj,
        wallet: selectedWallet,
      });
      if (
        musicartNftPurchaseRes?.data &&
        musicartNftPurchaseRes.data.status === 'success'
      ) {
        if (musicartNftPurchaseRes?.data?.txid) {
          settransactionTxid(musicartNftPurchaseRes.data.txid);
        }

        toast.success('NFT purchased successfully.', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
        //updating wallet balance
        getwalletBal(walletID, dispatch);
        handleClose();
        setconfirmationConfirmCheckoutDialogState(true);
        // router.push("/collection");
      } else if (
        musicartNftPurchaseRes?.data &&
        musicartNftPurchaseRes.data?.status === 'error'
      ) {
        toast.error(musicartNftPurchaseRes?.data.msg, {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
      } else {
        toast.error('An error occured!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });

        setloading(false);
      }
    } catch (err) {
      setloading(false);
      toast.error('An error occured, try again later', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
    }
  };

  const applyPromoCode = async (e) => {
    e.preventDefault();
    setpromocodeLoading(true);

    // try {
    if (props?.nftData?.buyWithCouponOnly) {
      if (promoCodeField && promoCodeField === props.nftData.buyWithCouponVal) {
        setpromoCodeObj({
          discountAmount: Number(props.nftData ? props.nftData.price : 0),
          discountedPrice: 0,
          couponVal: promoCodeField,
          buyWithCouponOnly: true,
        });
        toast.success('Coupon applied', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          zIndex: 2147483641,
        });
        setpromocodeLoading(false);
      } else {
        toast.error('Invalid coupon!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }
    } else {
      let dbRef;
      if (props.nftData.isMultiple) {
        const q = query(
          collection(
            firebaseFireStore,
            'musicartNfts',
            props.nftData.tokenId,
            'coupons',
          ),
          where('promoCode', '==', promoCodeField),
          where('nftId', '==', props.nftData.nftId),
        );

        dbRef = await getDocs(q);
      } else {
        const d = query(
          collection(
            firebaseFireStore,
            'musicartNfts',
            props.nftData.tokenId,
            'coupons',
          ),
          where('promoCode', '==', promoCodeField),
        );

        dbRef = await getDocs(d);
      }

      if (dbRef.empty) {
        //getting WITH_USAGE_LIMIT coupon
        const d = query(
          collection(
            firebaseFireStore,
            'musicartNfts',
            props.nftData.tokenId,
            'coupons',
          ),
          where('promoCode', '==', promoCodeField),
          where('couponType', '==', 'WITH_USAGE_LIMIT'),
          where('creatorId', '==', props.nftData.userId),
        );

        dbRef = await getDocs(d);
      }
      if (dbRef.empty) {
        toast.error('Coupon not found!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      let dataArr = [];
      dbRef.forEach((docd) => {
        let add = false;
        if (!props.nftData.isMultiple) {
          if (
            docd.data() &&
            (!docd.data().couponType ||
              docd.data().couponType !== 'WITH_USAGE_LIMIT')
          ) {
            add = true;
          } else if (
            docd.data() &&
            docd.data().couponType &&
            docd.data().couponType === 'WITH_USAGE_LIMIT' &&
            docd.data().creatorId === props.nftData.userId
          ) {
            add = true;
          }
        } else if (
          docd.data() &&
          docd.data().couponType &&
          docd.data().couponType === 'WITH_USAGE_LIMIT' &&
          docd.data().isMultiple
        ) {
          if (docd.data().subNfts && docd.data().subNfts[props.nftData.nftId]) {
            add = true;
          }
        } else {
          add = true;
        }

        if (add) {
          dataArr.push(docd.data());
        }
      });

      if (dataArr.length === 0 || !dataArr[0]) {
        toast.error('Coupon not found!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }
      let lobj = dataArr[0];

      let cTime = Number(moment().format('x'));
      if (cTime > Number(lobj.endTimestamp)) {
        toast.error('Coupon has been expired!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      } else if (cTime < Number(lobj.startTimestamp)) {
        toast.error('Coupon not started yet!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      //checking coupon usage limit
      if (
        lobj.couponType === 'WITH_USAGE_LIMIT' &&
        lobj.usageLimit &&
        lobj.usageLimit !== -1 &&
        lobj.usage >= lobj.usageLimit
      ) {
        toast.error('Coupon has been expired!', {
          position: 'bottom-left',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setpromocodeLoading(false);
        return null;
      }

      //valid promocode
      let discount;
      if (lobj.type === 'PERCENTAGE') {
        discount = Number(
          Number(props.nftData ? props.nftData.price : 0) *
            (Number(lobj.value) / 100),
        );
      } else {
        discount = Number(lobj.value);
        if (discount >= Number(props.nftData.price)) {
          discount = Number(props.nftData.price);
        }
      }
      setpromoCodeObj({
        ...lobj,
        discountAmount: discount,
        discountedPrice:
          Number(props.nftData ? props.nftData.price : 0) - discount,
      });
      toast.success('Coupon applied', {
        position: 'bottom-left',
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        zIndex: 2147483641,
      });
      setpromocodeLoading(false);
      // } catch (err) {
      // setpromocodeLoading(false);
      // toast.error(err.message, {
      //   position: "bottom-left",
      //   autoClose: 10000,
      //   hideProgressBar: false,
      //   closeOnClick: true,
      //   pauseOnHover: true,
      //   draggable: true,
      //   zIndex: 2147483641,
      // });
      // }
    }
  };

  useEffect(() => {
    if (props.dialogState) {
      setshowBuyingOpt('loading');
    }
  }, [props.dialogState]);
  useEffect(() => {
    if (render) {
      const element = document.querySelector('.fnCKZu');
      if (element) {
        element.style.height = '900px';
      }
    } else {
      setRender(true);
    }
  }, [render]);

  useEffect(() => {
    if (
      props?.nftData?.issuerID &&
      props?.nftData?.userId &&
      props.dialogState
    ) {
      handleStateCheck();
    }
  }, [props.nftData, props.dialogState]);

  const handleStateCheck = async () => {
    try {
      let ids = [];
      if (props.nftData.issuerID === props.nftData.userId) {
        ids.push(props.nftData.issuerID);
      } else {
        ids.push(props.nftData.issuerID);
        ids.push(props.nftData.userId);
      }

      let handleVerificationAPI = httpsCallable(
        firebaseFunctions,
        'verifyHandcashHandles',
      );
      let apiRes = await handleVerificationAPI({
        userIds: [...ids],
      });

      console.log('handleVerificationAPI', ids, apiRes);

      if (apiRes?.data?.isValid) {
        setshowUsdcOpt(true);
      } else {
        setshowUsdcOpt(false);
      }
      setshowBuyingOpt(true);
    } catch (err) {
      setshowUsdcOpt(false);
      setshowBuyingOpt(true);
    }
  };

  return (
    <>
      <Dialog
        open={props.dialogState}
        TransitionComponent={Transition}
        keepMounted
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          style: {
            borderRadius: 20,
            width: 380,
          },
        }}
        disableScrollLock={false}
        style={{ zIndex: 999 }}
        maxWidth="sm"
        onClose={handleClose}
        TransitionProps={{
          tabIndex: 'none',
        }}
      >
        <div>
          <div className="dialog-titlebar">
            <div className="dialog-title">Checkout</div>
            <div className="dialog-close">
              <button
                className="bg-white text-black my-2 text-lg font-light h-10 w-10 items-center justify-center align-center rounded-full outline-none focus:outline-none border border-gray-300"
                type="button"
                onClick={handleClose}
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div>
            <DialogContent>
              <div>
                <div className="py-3">
                  <label className="text-black text-base font-medium mb-4">
                    You are about to purchase{' '}
                    <span className="italic">
                      {props.nftData && props.nftData.tokenName}{' '}
                    </span>
                    <span>
                      from <span className="italic">@{props.ownerName}</span>
                    </span>
                  </label>
                </div>
                <div className="py-3 border-b">
                  <label className="text-gray-500">
                    Item Cost (${' '}
                    {props.nftData && props.nftData.price
                      ? props.nftData.price.toFixed(2)
                      : ''}
                    )
                  </label>
                  <label className="float-right">
                    {props.nftData
                      ? (props.nftData.price / bsvRate).toFixed(4)
                      : 0}{' '}
                    BSV
                  </label>
                </div>

                {promoCodeObj && (
                  <div className="py-2">
                    <label className="text-gray-500">Coupon</label>
                    <label className="float-right">
                      <span
                        className="link ml-2"
                        onClick={() => {
                          setpromoCodeObj(null);
                        }}
                      >
                        -
                      </span>{' '}
                      ({promoCodeObj.discountAmount}) BSV
                    </label>
                  </div>
                )}
                <div className="py-2">
                  <label className="text-gray-500">
                    You will pay (${' '}
                    {promoCodeObj &&
                    props.nftData &&
                    (promoCodeObj.discountedPrice ||
                      promoCodeObj.discountedPrice === 0)
                      ? promoCodeObj.discountedPrice.toFixed(2)
                      : props.nftData
                      ? props.nftData &&
                        props.nftData.price &&
                        props.nftData.price.toFixed(2)
                      : 0}
                    )
                  </label>
                  <label className="float-right">
                    {promoCodeObj &&
                    props.nftData &&
                    (promoCodeObj.discountedPrice ||
                      promoCodeObj.discountedPrice === 0)
                      ? (promoCodeObj.discountedPrice / bsvRate).toFixed(4)
                      : props.nftData
                      ? (props.nftData.price / bsvRate).toFixed(4)
                      : ''}
                    {''} BSV
                  </label>
                </div>

                <div className="py-2">
                  <form
                    onSubmit={applyPromoCode}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      // flexWrap: 'wrap',
                    }}
                  >
                    <div
                      style={{
                        position: 'relative',
                        // border: "2px solid red",
                        overflow: 'hidden',
                      }}
                    >
                      <input
                        type="text"
                        placeholder="Coupon"
                        className="coupon_input_box"
                        style={{
                          height: 30,
                          width: 150,
                        }}
                        value={promoCodeField}
                        onChange={(e) => {
                          setpromoCodeField(e.target.value);
                        }}
                        required
                      />
                      {promoCodeField && promoCodeField.length > 0 && (
                        <button
                          type="button"
                          onClick={() => {
                            setpromoCodeField('');
                            setpromoCodeObj(null);
                          }}
                          className="close_icon"
                          style={{
                            bottom: 5,
                            right: 5,
                            height: 'auto',
                          }}
                        >
                          <HighlightOffIcon />
                        </button>
                      )}
                    </div>
                    <div
                      className="text-gray-500 ml-2 "
                      style={{ width: 100, textAlign: 'center' }}
                    >
                      {promocodeLoading ? (
                        <div className="block">
                          <Skeleton animation="wave" height={20} width="60%" />
                        </div>
                      ) : (
                        <button
                          className="link link_text text_in_one_line"
                          type="submit"
                        >
                          Apply Code
                        </button>
                      )}
                    </div>
                  </form>
                </div>
              </div>
              <div></div>

              <div className="sign__group sign__group--checkbox custom_check">
                <input
                  id="isAgreedPolicy"
                  name="isAgreedPolicy"
                  type="checkbox"
                  onChange={onPolicy}
                  checked={isAgreedPolicy}
                />
                <label htmlFor="isAgreedPolicy">
                  I have read and agree to the&nbsp;
                  <a href="/privacy-policy" target="_blank">
                    Privacy Policy.
                  </a>
                </label>
              </div>
              <div className="sign__group sign__group--checkbox custom_check">
                <input
                  id="isAgreedTerms"
                  name="isAgreedTerms"
                  type="checkbox"
                  onChange={onTerms}
                  checked={isAgreedTerms}
                />
                <label htmlFor="isAgreedTerms">
                  I have read and agree to the&nbsp;
                  <a href="/terms-of-service" target="_blank">
                    Terms of Service.
                  </a>
                </label>
              </div>
            </DialogContent>

            <DialogActions
              style={{
                paddingTop: 10,
                paddingBottom: 10,
                justifyContent: 'center',
                boxSizing: 'border-box',
                flexDirection: 'column',
              }}
            >
              <div></div>
              {showBuyingOpt === true ? (
                <>
                  <Radio.Group
                    onChange={(e) => {
                      setselectedWallet(e.target.value);
                    }}
                    value={selectedWallet}
                    style={{ width: '100%' }}
                    className="mb-6"
                  >
                    <div className="w-full px-4 mb-2">
                      <button
                        className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                          selectedWallet === musicartWallet
                            ? 'wallet_selected_dialog__btn'
                            : ''
                        }`}
                        type="button"
                        onClick={() => setselectedWallet(musicartWallet)}
                        style={{ textTransform: 'none' }}
                      >
                        <div
                          className="flex align-center"
                          style={{
                            justifyContent: 'center',
                            alignItems: 'center',
                          }}
                        >
                          <div>
                            {' '}
                            MusicArt Wallet (BSV)
                            <br />
                            Balance:{' '}
                            {userWalletRedux && userWalletRedux.balance
                              ? userWalletRedux.balance.toFixed(4)
                              : 0}{' '}
                            BSV ($
                            {bsvRate &&
                            userWalletRedux &&
                            userWalletRedux.balance
                              ? formatUSDBalance(
                                  userWalletRedux.balance * bsvRate,
                                )
                              : 0}
                            )
                          </div>
                          <div style={{ position: 'absolute', right: 0 }}>
                            <Radio value={musicartWallet}> </Radio>
                          </div>
                        </div>
                      </button>
                    </div>
                    {handCashWalletRedux?.balance &&
                      handCashWalletRedux?.balance[1] && (
                        <div className="w-full px-4 mb-2">
                          <button
                            className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                              selectedWallet === handCashBSVWallet
                                ? 'wallet_selected_dialog__btn'
                                : ''
                            }`}
                            type="button"
                            onClick={() => setselectedWallet(handCashBSVWallet)}
                            style={{ textTransform: 'none' }}
                          >
                            <div>
                              {' '}
                              HandCash Wallet (BSV)
                              <br />
                              Balance:{' '}
                              {handCashWalletRedux?.balance[1]?.spendableBalance
                                ? handCashWalletRedux.balance[1].spendableBalance.toFixed(
                                    4,
                                  )
                                : 0}{' '}
                              BSV ($
                              {bsvRate &&
                              handCashWalletRedux?.balance[1]?.spendableBalance
                                ? (
                                    handCashWalletRedux.balance[1]
                                      .spendableBalance * bsvRate
                                  ).toFixed(2)
                                : 0}
                              )
                            </div>
                            <div style={{ position: 'absolute', right: 0 }}>
                              <Radio value={handCashBSVWallet}> </Radio>
                            </div>
                          </button>
                        </div>
                      )}
                    {/* {showUsdcOpt &&
                      handCashWalletRedux?.balance &&
                      handCashWalletRedux?.balance[0] && (
                        <div className="w-full px-4 ">
                          <button
                            className={`wallet_sel_dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full ${
                              selectedWallet === handCashUSDCWallet
                                ? 'wallet_selected_dialog__btn'
                                : ''
                            }`}
                            type="button"
                            onClick={() =>
                              setselectedWallet(handCashUSDCWallet)
                            }
                            style={{ textTransform: 'none' }}
                          >
                            <div>
                              {' '}
                              HandCash Wallet (USDC)
                              <br />
                              Balance:{' '}
                              {handCashWalletRedux?.balance[0]?.spendableBalance
                                ? handCashWalletRedux.balance[0]
                                    .spendableBalance
                                : 0}{' '}
                              USDC ($
                              {handCashWalletRedux?.balance[0]?.spendableBalance
                                ? handCashWalletRedux.balance[0]
                                    .spendableBalance
                                : 0}
                              )
                            </div>
                            <div style={{ position: 'absolute', right: 0 }}>
                              <Radio value={handCashUSDCWallet}> </Radio>
                            </div>
                          </button>
                        </div>
                      )} */}
                  </Radio.Group>

                  {(() => {
                    if (loading) {
                      return (
                        <div className="flex justify-center	w-full mb-6">
                          <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                        </div>
                      );
                    } else {
                      return (
                        <div className="w-full mb-4 px-4">
                          <button
                            className="dialog__btn py-3 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                            type="button"
                            onClick={confirmPurchase}
                          >
                            Pay with wallet
                          </button>
                          <button
                            className="dialog__btn dialog__btn--white py-3 my-2 rounded-full hover:outline-none focus:outline-none ease-linear w-full"
                            type="button"
                            onClick={handleClose}
                          >
                            Cancel
                          </button>
                        </div>
                      );
                    }
                  })()}
                </>
              ) : (
                <div className="flex justify-center	w-full mt-4 mb-12">
                  <i className="fas fa-circle-notch animate-spin text-blueGray-800 mx-auto"></i>
                </div>
              )}
            </DialogActions>
          </div>
        </div>
      </Dialog>

      <ConfirmCheckoutDialog
        dialogState={confirmationConfirmCheckoutDialogState}
        setdialogState={setconfirmationConfirmCheckoutDialogState}
        nftData={props.nftData}
        txid={transactionTxid}
        ownerName={props.ownerName}
        nftUrl={props.nftUrl}
      />
    </>
  );
}
